@if (dataSource) {
  <icz-documents-table
    class="grow" iczAutoFocus
    tableTitle="Globální vyhledávání"
    [tableId]="globalSearchTableId"
    [viewType]="DocumentView.GLOBAL_SEARCH"
    [dataSource]="dataSource"
    [searchTerm]="searchTerm"
    [enabledFilters]="enabledFilters"
    (pageLoadStarted)="pageLoadStarted($event)"
    (editQueryRequested)="editComplexQuery()"
  >
    <ng-container afterTableTitle>
      @if ((dataSource.paginator?.totalItems() ?? 0) > GLOBAL_SEARCH_RESULT_COUNT_LIMIT) {
        <icz-alert
          severity="warning" class="icz-body-1 px-12 py-0"
          heading="Vyhledávacím kritériím odpovídá příliš mnoho výsledků"
          [label]="tooManyResultsWarningLabel"
          [textContext]="{ limit: GLOBAL_SEARCH_RESULT_COUNT_LIMIT }"
        ></icz-alert>
      }
    </ng-container>
    <icz-label noDataLabel label="Žádné dokumenty nenalezeny"></icz-label>
  </icz-documents-table>
}
